<template>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="textcard">
      <h2>Quick recap;<br>
        The cool things you will get:
      </h2>
      <br>
      <ul>
        <li>Back-connect rotating proxies</li>
        <li>Unlimited concurrent connections</li>
        <li>HTTP and HTTPs proxies</li>
        <li>7 million IP proxy network</li>
        <li id="pricing">Username & password authentication</li>
        <li>Select countries all around the globe</li>
        <li>Outstanding support that's ready to help you</li>

      </ul>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="imagecard">
      <img
        src="https://cdn.proxyscrape.com/img/how_residential_work.jpg"
        alt="how a residential proxy works">
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
